import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  useEffect(() => {
    const token = localStorage.getItem("boothiq_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("boothiq_token");
        setUser(false);
      });
  }, []);

  const login = async (email, pin) => {
    const { data } = await api.post("/auth/login", { email, pin });
    localStorage.setItem("boothiq_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem("boothiq_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
